import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_STATISTICS_100PAB_IN_ENTRANCE_API_URL, GET_STATISTICS_3K_CHAIN_API_URL, GET_STATISTICS_ACCOUNT_EXCEL_API_URL, GET_STATISTICS_ACTIVE_KTV_API_URL, GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL, GET_STATISTICS_CABLE_ACCOUNT_API_URL, GET_STATISTICS_CABLE_CANTON_API_URL, GET_STATISTICS_CABLE_EXCEL_API_URL, GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL, NETSTAT_SWITCH_TOPO_URL, NETSTAT_SWITCH_URL } from '../OpticApiConfig';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { loadingCanton } from '../LoadingData/LoadingDataTerritory';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const Statistic100pabInEntance = () => {
  const [selectedCanton, setSelectedCanton] = useState('');
  const [groups, setGroups] = useState([]);
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [error, setError] = useState(null);  
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const [canton, setCanton] = useState([]);
  
  useEffect(() => {
    loadingCanton(setCanton); 
  }, []); 

  const getCapacityColor = (percent) => {
    if (percent >= 70) return "#ff4d4d"; // красный
    if (percent >= 50) return "#ffd700"; // желтый
    return "#92fd88"; // зеленый
  };

  const handleButtonClick = async () => {
    if (!selectedCanton) {
      setError('Пожалуйста, выберите округ.');
      return;
    }

    try {
      setError(null);
      setLoading(true); 
      const response = await axios.get(GET_STATISTICS_100PAB_IN_ENTRANCE_API_URL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { canton: selectedCanton }
      });

      setGroups(response.data ?? []);
      setFilteredGroups(response.data ?? []);
    } catch (error) {
      console.error(error);
      setError('Произошла ошибка при загрузке данных.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
        <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px", textShadow: '2px 2px 4px rgba(7, 7, 7, 1)' }}>
           Больше 2-х свитчей в подъезде
          </label>
          <Select
            className="selectSearchDrawer"
            options={canton.map(option => ({ value: option, label: option }))}
            isSearchable={true}
            styles={customStyles}
            placeholder="Округ"
            onChange={(selectedOption) => setSelectedCanton(selectedOption.value)} 
          />
          <button 
            className='buttonAutoTopology' 
            style={{ marginTop: "0px", padding: "10px" }}
            onClick={handleButtonClick} 
          >
            Загрузить
          </button>
        </div>
        <hr className="horizontalLineDrawer" style={{ marginTop: "0px" }} />
      </div>

      {loading && <div style={{ color: "#92fd88b3", marginLeft: "10px" }}>Загрузка данных...</div>}

      {!loading && error && <div style={{ color: "red", marginLeft: "10px" }}>{error}</div>}

      {!loading && filteredGroups?.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', maxHeight: "80vh", overflowY: "auto" }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <label style={{ marginLeft: '10px', color: "#c5c5c5", textShadow: '2px 2px 4px #131212ff'}}>
              Всего групп: <span style={{color: "orange"}}>{filteredGroups?.length ?? 0}</span>
            </label>
          </div>

          {filteredGroups.map((group, idx) => (
            <div key={idx} style={{ border: '1px solid #444', borderRadius: '8px', padding: '10px', background: '#1b1b1b' }}>
              
              {/* Инфо о группе */}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', color: '#c5c5c5', fontWeight: 'bold' }}>
                <span>Улица: {group.switches?.[0]?.street ?? '-'}</span>
                <span>Дом: {group.switches?.[0]?.house ?? '-'}</span>
                <span>Подъезд: {group.entrance ?? '-'}</span>
                <span>Свитчей: {group.switchCount ?? 0}</span>
                <span>Всего абонов: {group.totalAbonCount ?? 0}</span>
                <span style={{ color: getCapacityColor(group.groupCapacityPercent ?? 0) }}>
                  Емкость группы: {(group.groupCapacityPercent ?? 0).toFixed(2)}%
                </span>
              </div>

              {/* Таблица свитчей внутри группы */}
              <table className="results-table" style={{ fontSize: '14px', tableLayout: 'fixed', width: '100%' }}>
                <thead>
                  <tr>
                    <th>Модель</th>
                    <th>IP</th>
                    <th>Абонов</th>
                    <th>Емкость %</th>
                  </tr>
                </thead>
                <tbody>
                  {group.switches?.length > 0 ? group.switches.map((sw, i) => (
                    <tr key={i}>
                      <td className="text-shadow-statistics">{sw.model}</td>
                      <td className="text-shadow-statistics">
                        <a
                          href={`${NETSTAT_SWITCH_URL}?ip=${sw.ip?.toLowerCase()}&action=up`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#92fd88b3" }}
                        >
                          {sw.ip?.toLowerCase()}
                        </a>
                      </td>
                      <td className="text-shadow-statistics">{sw.abonCount ?? 0}</td>
                      <td className="text-shadow-statistics" style={{ color: getCapacityColor(sw.capacityPercent ?? 0) }}>
                        {(sw.capacityPercent ?? 0).toFixed(2)}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="4" className="no-data">Нет свитчей в этой группе</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}

      {!loading && !filteredGroups?.length && <div style={{ color: "#c5c5c5", marginLeft: "10px" }}>Нет данных для отображения</div>}
    </>
  );
};

export default Statistic100pabInEntance;